import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
// Lazy load ALL non-LCP components
const UrgencyBar = lazy(() => import('./components/UrgencyBar').then(m => ({
  default: m.UrgencyBar
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const ExamplesSection = lazy(() => import('./components/ExamplesSection').then(m => ({
  default: m.ExamplesSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ComboSelector = lazy(() => import('./components/ComboSelector').then(m => ({
  default: m.ComboSelector
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-0">
      <Suspense fallback={<div className="h-12 bg-red-600" data-id="element-2" />} data-id="element-1">
        <UrgencyBar data-id="element-3" />
      </Suspense>
      <Suspense fallback={null} data-id="element-4">
        <PurchasePopup data-id="element-5" />
      </Suspense>

      <main className="pt-12" data-id="element-6">
        <HeroSection data-id="element-7" />
        <Suspense fallback={null} data-id="element-8">
          <PainSection data-id="element-9" />
          <SolutionSection data-id="element-10" />
          <ProductSection data-id="element-11" />
          <ExamplesSection data-id="element-12" />
          <BonusSection data-id="element-13" />
          <ComboSelector data-id="element-14" />
          <GuaranteeSection data-id="element-15" />
          <FAQSection data-id="element-16" />
          <FinalCTA data-id="element-17" />
          <TestimonialsSection data-id="element-18" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-19">
        <FooterSection data-id="element-20" />
      </Suspense>
    </div>;
}